const DASHBOARD_TOUR_STEPS = [
  {
    id: 'welcome',
    target: '[data-tour="transfer-calculator"]',
    placement: 'top',
    title: (
      <>
        Welcome to <span className='tour-brand'>HansePay</span>.
      </>
    ),
    text: 'Your financial dashboard is ready. This short tour will show you the key features — it only takes a minute.',
  },
  {
    id: 'overview',
    target: '[data-tour="dashboard-overview"]',
    placement: 'bottom',
    title: 'Your dashboard',
    text: 'Your current balance is always visible here. Use Add Money to top up your account and Send Money to start a transfer.',
  },
  {
    id: 'send-money',
    target: '[data-tour="sidebar-send-money"]',
    placement: 'right',
    title: 'Send money abroad',
    text: "Click Send Money to start a transfer. Choose your destination, enter the amount, add your recipient details — and confirm. We're faster than your bank.",
  },
  {
    id: 'calculator',
    target: '[data-tour="transfer-calculator"]',
    placement: 'top',
    title: 'Know your rate before you send',
    text: 'Use the Transfer Calculator to check live exchange rates for any currency pair before committing to a transfer.',
    isLast: true,
  },
];

export default DASHBOARD_TOUR_STEPS;
